/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ companyName: NonNullable<unknown> }} Welcome_Contact_Companyinvestorservices2Inputs */

const en_welcome_contact_companyinvestorservices2 = /** @type {(inputs: Welcome_Contact_Companyinvestorservices2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.companyName} Investor Services`)
};

/**
* | output |
* | --- |
* | "{companyName} Investor Services" |
*
* @param {Welcome_Contact_Companyinvestorservices2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const welcome_contact_companyinvestorservices2 = /** @type {((inputs: Welcome_Contact_Companyinvestorservices2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Contact_Companyinvestorservices2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_contact_companyinvestorservices2(inputs)
});
export { welcome_contact_companyinvestorservices2 as "welcome_contact_companyInvestorServices" }